import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { ResolutionStore } from '../stores/resolutionStore';

export const useResolutionStore = () =>
  useContext<{
    resolutionStore: ResolutionStore;
  }>(StoreContext);